<template>
  <section>
    <!-- 里程工资 -->
    <section v-show="salaryPattern === '2'">
      <section class="titleLine">
        里程工资设置（从左到右）
        <span
          class="select-btn primary cur"
          @click="selectTemplate(meterList, '2')"
        >
          选择模板
        </span>
        <span
          class="add-template-btn primary cur"
          @click="editTemplate(meterList, '2')"
        >
          将里程区间及单价保存成模板
        </span>
      </section>
      <section
        class="salary-item-box"
        v-for="(item, index) in meterList"
        :key="item.id"
      >
        <span class="labelText">里程工资{{ index + 1 }}</span>
        <el-input
          class="appendInputBox"
          v-model="item.endNum"
          placeholder="里程数值"
          @keyup.native="handleChange('meterList', index)"
        >
          <section slot="prefix">
            <el-input
              class="inputAppendInput"
              v-model="item.startNum"
              :disabled="true"
              placeholder="里程数值"
            />
            至
          </section>
          <section class="inputUnit" slot="suffix">KM</section>
        </el-input>
        <el-input
          class="inputBox small-input-box"
          v-model="item.price"
          placeholder="里程单价"
        >
          <section class="inputUnit" slot="suffix">元/KM</section>
        </el-input>
        <i
          class="el-icon-error delBtn cur"
          v-if="index === meterList.length - 1 && index !== 0"
          @click="del('meterList')"
        />

        <el-button
          class="add-item-Btn"
          type="primary"
          plain
          v-if="index === meterList.length - 1"
          @click="add('meterList')"
        >
          <i class="el-icon-plus" />增加
        </el-button>
      </section>
    </section>
    <!-- 里程工资 end -->
    <!-- 趟数工资 -->
    <section v-show="salaryPattern === '3'">
      <section class="titleLine">
        趟数工资设置（从左到右）
        <span
          class="select-btn primary cur"
          @click="selectTemplate(tripList, '3')"
        >
          选择模板
        </span>
        <span
          class="add-template-btn primary cur"
          @click="editTemplate(tripList, '3')"
        >
          将里程区间及单价保存成模板
        </span>
      </section>
      <section
        class="salary-item-box"
        v-for="(item, index) in tripList"
        :key="item.id"
      >
        <span class="labelText">趟数工资{{ index + 1 }}</span>
        <el-input
          class="appendInputBox"
          v-model="item.endNum"
          placeholder="趟数数值"
          @keyup.native="handleChange('tripList', index)"
        >
          <section slot="prefix">
            <el-input
              class="inputAppendInput"
              v-model="item.startNum"
              :disabled="true"
              placeholder="趟数数值"
            />
            至
          </section>
          <section class="inputUnit" slot="suffix">趟</section>
        </el-input>
        <el-input
          class="inputBox small-input-box"
          v-model="item.price"
          placeholder="趟数单价"
        >
          <section class="inputUnit" slot="suffix">元/趟</section>
        </el-input>
        <i
          class="el-icon-error delBtn cur"
          v-if="index === tripList.length - 1 && index !== 0"
          @click="del('tripList')"
        />

        <el-button
          class="add-item-Btn"
          type="primary"
          plain
          v-if="index === tripList.length - 1"
          @click="add('tripList')"
        >
          <i class="el-icon-plus" />增加
        </el-button>
      </section>
    </section>
    <!-- 趟数工资 end -->
    <SalaryTemplateAddDialog ref="salaryTemplateAddDialog" />
    <SalaryTemplateSelectDialog
      ref="salaryTemplateSelectDialog"
      @sub="getSelectTemplate"
    />
  </section>
</template>

<script>
import SalaryTemplateAddDialog from './salaryTemplateAddDialog';
import SalaryTemplateSelectDialog from './salaryTemplateSelectDialog';
export default {
  props: {
    salaryPattern: {
      type: String,
      default: '',
    },
  },
  components: {
    SalaryTemplateAddDialog,
    SalaryTemplateSelectDialog,
  },
  data () {
    return {
      meterList: [{
        startNum: 0,
        endNum: '',
        price: '',
      }],
      tripList: [{
        startNum: 0,
        endNum: '',
        price: '',
      }],
    };
  },
  methods: {
    add (tar) { // 添加
      let startNum = '';
      if (this[tar][this[tar].length - 1].endNum > 0) {
        startNum = Number(this[tar][this[tar].length - 1].endNum) + 1;
      }
      this[tar].push({
        startNum,
        endNum: '',
        price: '',
      });
    },
    del (tar) { // 删除
      this[tar].splice(this[tar].length - 1, 1);
    },
    // 选择模板
    selectTemplate (item, salaryPattern) {
      this.$refs.salaryTemplateSelectDialog.show(item, salaryPattern);
    },
    // 添加/修改模板
    editTemplate (item, salaryPattern) {
      this.$refs.salaryTemplateAddDialog.show(item, salaryPattern);
    },
    // 获取选择的模板
    getSelectTemplate (templateData) {
      if (this.salaryPattern === '2') {
        this.meterList = templateData.fieldList;
      }
      if (this.salaryPattern === '3') {
        this.tripList = templateData.fieldList;
      }
    },
    handleChange (tar, index) { // 数值变化
      if (index === this[tar].length - 1) {
        return;
      }
      if (isNaN(this[tar][index].endNum)) {
        return;
      }
      this[tar][index + 1].startNum = Number(this[tar][index].endNum) + 1;
    },
    init (data) {
      if (data.salaryPattern === '2') {
        this.meterList = data.userSalaryInfoList || [{
          startNum: 0,
          endNum: '',
          price: '',
        }];
        this.meterList = this.meterList.map((item) => ({
          startNum: item.startNum,
          endNum: item.endNum,
          price: item.priceDouble,
        }));
      } else if (data.salaryPattern === '3') {
        this.tripList = data.userSalaryInfoList || [{
          startNum: 0,
          endNum: '',
          price: '',
        }];
        this.tripList = this.tripList.map((item) => ({
          startNum: item.startNum,
          endNum: item.endNum,
          price: item.priceDouble,
        }));
      }
    },
    sub () {
      if (this.salaryPattern === '2') {
        return this.meterList;
      } else if (this.salaryPattern === '3') {
        return this.tripList;
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.titleLine {
  background: #fafafa;
  height: 40px;
  line-height: 40px;
  padding: 0 40px;
  .addBtn {
    margin-left: 24px;
  }
  .select-btn {
    margin-left: 24px;
  }
  .add-template-btn {
    float: right;
  }
}
.labelText {
  margin-right: 32px;
  color: #666;
  padding-left: 64px;
}
.smallInputBox {
  width: 160px;
  margin-left: 16px;
  margin-top: 16px;
}
.appendInputBox {
  ::v-deep input {
    padding-left: 150px;
  }
}
.inputAppendInput {
  position: relative;
  left: -8px;
  ::v-deep input {
    border-right: none;
    padding-left: 30px;
  }
}
.delBtn {
  font-size: 16px;
  margin-left: 16px;
  color: #999;
}

.salary-item-box {
  display: flex;
  align-items: center;
  margin-top: 16px;
  .small-input-box {
    width: 160px;
    margin-left: 16px;
  }
  .add-item-Btn {
    margin-left: 16px;
    height: 32px;
  }
}
</style>
